import React, { useEffect } from "react";
import { useFetch2 } from "components/utils/authenticatedHook";
import ExtremeExceptionsDetails from "../../Rules/ExtremeExceptionsDetails";

function AdminExtremeExceptionsDetails(props) {
  const [{ response: readingTypeAndConditions }, doFetch] = useFetch2();

  useEffect(() => {
    doFetch({
      url: "/get-extreme-reading-type-and-condition",
      method: "GET",
    });
  }, []);

  return (
    <ExtremeExceptionsDetails
      {...props}
      readingTypeAndConditions={readingTypeAndConditions}
    />
  );
}

export default AdminExtremeExceptionsDetails;
